// frontend/src/pages/NewJuvenilePage.js (Corrected)
import React from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../api'; // Use our configured apiClient
import JuvenileForm from '../components/JuvenileForm';

function NewJuvenilePage() {
  const navigate = useNavigate();

  const handleCreate = async (formData) => {
    try {
      // The apiClient handles the URL and auth token automatically
      const response = await apiClient.post('/api/juveniles', formData);
      // Navigate to the new juvenile's detail page after creation
      navigate(`/juveniles/${response.data.id}`);
    } catch (err) {
      console.error("Failed to create juvenile", err);
      // You could add error state and display a message to the user
    }
  };

  return (
    <div>
      <h1 className="text-2xl font-bold text-slate-800 mb-4">Create New Juvenile Profile</h1>
      <JuvenileForm onSubmit={handleCreate} />
    </div>
  );
}

export default NewJuvenilePage;